(function() {
  'use strict';
  angular.module('ringbaPortal').controller('StatsDetailController', StatsDetailController);

  function StatsDetailController(
    _,
    moment,
    statsService,
    timeFormatService
  ) {
    'ngInject';

    const vm = this;

    const messageTypeToLabelMap = {
      'INT': {
        yAxisParams: {
          id: 'count-axis',
          title: {
            text: 'Call Counts'
          }
        },
        series: {
          animation: false,
          yAxis: 'count-axis',
          type: 'spline'
        }
      },
      'TIME_IN_SECONDS': {
        yAxisParams: {
          id: 'time-axis',
          title: {
            text: 'Time (mm:ss)'
          },
          labels: {
            formatter: function() {
              return timeFormatService.secondsToMinutesFormat(this.value);
            }
          },
          opposite: true,
        },
        series: {
          animation: false,
          yAxis: 'time-axis',
          tooltip: {
            pointFormatter: function() {
              const ser = this.series;
              return '<span style="color:' + ser.color + '" >\u25CF</span> ' +
              ser.name + ': <b>' + timeFormatService.secondsToMinutesFormat(this.y) + '</b><br>';
            }
          },
          type: 'line',
        }
      },
      'CURRENCY': {
        yAxisParams: {
          id: 'currency-axis',
          title: {
            text: 'Amount'
          },
          labels: {
            format: '${value}'
          },
          opposite: true,
        },
        series: {
          animation: false,
          yAxis: 'currency-axis',
          tooltip: {
            valuePrefix: '$'
          },
          type: 'column',
          borderColor: 'transparent',
          zIndex: -1,
        }
      }
    };

    const defaultSeriesObj = {
      data: [],
      marker : {
        enabled : true,
        radius : 3
      },
    };

    vm.chartConfig = angular.copy(statsService.statsOptions);

    vm.$onChanges = onChanges;
    vm.statsService = statsService;

    function onChanges() {
      if(vm.stat) {
        _loadData(vm.stat);
      }
    }

    // TODO: Refactor this
    function _loadData(eventNames) {
      const series = [];
      let yAxis = [];

      const stats = _.filter(vm.statsService.stats, function(stat) {
        return eventNames.indexOf(stat.messageName) > -1;
      });
      
      if (stats.length > 0) {
        _.forEach(eventNames, function(messageName, index) {
          const filteredStats = _.find(stats, { messageName: messageName });
          yAxis.push(_.merge({}, {
            min: 0,
            // Highcharts defaults, which the app theme would otherwise replace.
            gridLineColor: '#e6e6e6',
            tickWidth: 0
          }, messageTypeToLabelMap[filteredStats.messageType].yAxisParams));

          series.push(_.merge({}, defaultSeriesObj, messageTypeToLabelMap[filteredStats.messageType].series, {
            color: vm.statsService.fileMap[filteredStats.messageName] ? vm.statsService.fileMap[filteredStats.messageName].background : vm.statsService.fileMap['default'].background
          }));
          series[index]['name'] = messageName;
  
          const values = filteredStats.values;
          const offset= filteredStats.utc_offset;
          // TODO: refactor this foreach and reduce above into a single transform
          _.forEach(values, function(value, valueIndex) {
            const hour = new Date(filteredStats.startTime);
            hour.setHours(hour.getHours()+valueIndex);
            series[index].data.push({
              x: moment(hour).add(offset,'hour').unix() * 1000,
              y: value
            });
          });

        });
      }

      yAxis = _.uniqBy(yAxis, 'id');
      
      // The highcharts-ng wrapper does not handle dynamic addition and removal of yAxes,
      // so we handle it here.
      _handleRemoveAndAddYAxis(yAxis); 

      vm.chartConfig.yAxis = yAxis;
      vm.chartConfig.series = series;
    }
    
    function _handleRemoveAndAddYAxis(newYAxis) {
      if(vm.chartConfig && vm.chartConfig.getHighcharts) {
        const highchartsObj = vm.chartConfig.getHighcharts();
        if(!_.isEqual(vm.chartConfig.yAxis, newYAxis)) {
          _removeUnwantedYAxis(newYAxis, vm.chartConfig.yAxis, highchartsObj);
          _addNewYAxis(newYAxis, vm.chartConfig.yAxis, highchartsObj);
        }
      }
    }

    function _addNewYAxis(newYAxis, chartYAxis, highchartsObj) {
      const toAdd = _.differenceBy(newYAxis, chartYAxis, 'id');
      _.forEach(toAdd, function(addAxisObj) {
        _addYAxis(highchartsObj, addAxisObj);
      });
    }

    function _removeUnwantedYAxis(newYAxis, chartYAxis, highchartsObj) {
      _.forEach(chartYAxis, function(axis) {
        const remove = !_.find(newYAxis, function(search) {
          return search.id === axis.id;
        });
        if(remove) {
          _removeYAxis(highchartsObj, axis.id);
        }
      });
    }

    function _removeYAxis(highchartsObj, yAxisId) {
      const axis = highchartsObj.get(yAxisId);
      axis && axis.remove(true);
    }

    function _addYAxis(highchartsObj, addAxisObj) {
      if(!highchartsObj.get(addAxisObj.id)) {
        highchartsObj.addAxis(addAxisObj);
      }
    }

    
  }
})();
